<template>
  <div id="contenedor-opciones-tool-bar">
    <v-tabs>
      <template v-for="(opcion, index) in opciones">
        <v-tab :key="index" :to="{ name: opcion.ruta }" exact>
          {{ opcion.nombre }}
        </v-tab>
      </template>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'obra',
          icono: '',
        },
        {
          nombre: 'Archivos Relacionados',
          ruta: 'obraDocumentosRelacionados',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
